const cv = {
  "basics": {
    "name": "David Granjon",
    "label": "Lead Shiny, cynkra",
    "image": "https://avatars.githubusercontent.com/divadnojnarg",
    "email": "dgranjon[at]ymail.com",
    "phone": "",
    "url": "",
    "summary": "UI/UX design, CICD addict, Cycling guru.",
    "location": {
      "address": "",
      "postalCode": "",
      "city": "Zurich",
      "countryCode": "CH"
    },
    "social": [
      {
        "network": "Mastodon",
        "username": "davidgranjon",
        "url": "https://fosstodon.org/@davidgranjon"
      },
      {
        "network": "Linkedin",
        "username": "David Granjon",
        "url": "https://www.linkedin.com/in/david-granjon-88625968/"
      },
      {
        "network": "GitHub",
        "username": "DivadNojnarg",
        "url": "https://github.com/DivadNojnarg"
      },
      {
        "network": "GitLab",
        "username": "dgranj",
        "url": "https://gitlab.com/dgranj"
      }
    ]
  },
  "work": [
    {
      "compagny": "cynkra",
      "position": "Lead Shiny",
      "url": "https://www.cynkra.com/",
      "startDate": "2023-09",
      "endDate": "Present",
      "summary": "",
      "highlights": []
    },
    {
      "compagny": "Novartis AG",
      "position": "Senior Data Science Expert",
      "url": "",
      "startDate": "2021-06",
      "endDate": "2023-08",
      "summary": "",
      "highlights": [
        "Responsible for CICD infrastructure to test and deploy R-related content (GitLab runners, Docker, OpenShift).",
        "Promote best practices for R development from ideation to deployment in production (User requirements, wireframing, mockups, version control, renv, testing).",
        "Development of production Shiny apps (DMC, Probability of Success, ...)."
      ]
    },
    {
      "compagny": "RinteRface",
      "position": "Founder and maintainer",
      "url": "https://rinterface.com/",
      "startDate": "2018-11",
      "endDate": "Present",
      "summary": "",
      "highlights": [
        "Develop and maintain high quality open source R packages for Shiny apps."
      ]
    },
    {
      "compagny": "Novartis AG",
      "position": "Principal Scientist and Consultant",
      "url": "",
      "startDate": "2019-06",
      "endDate": "2021-06",
      "summary": "",
      "highlights": [
        "Support Novartis associates to develop production ready Shiny apps for clinical activities.",
        "Deliver high quality workshops to promote best practices around Shiny apps development.",
        "Maintain internal tools: R packages, databases, web servers, ...",
        "Represent Novartis at international R conferences."
      ]
    },
    {
      "compagny": "The Interface Group, University of Zurich (UZH)",
      "position": "Software engineer",
      "url": "",
      "startDate": "2017-06",
      "endDate": "2019-06",
      "summary": "",
      "highlights": [
        "Design user-friendly interfaces of Calcium and Phosphate Homeostasis, using the R-Shiny package, javascript and C. Management of linux web servers. Design new interactive tools dedicated to teaching courses.",
        "Develop a model linking the cardiac and renal functions, to better understand the interplay between chronic kidney disease as well as cardiac failure. Create virtual patient populations using Monte Carlo simulations."
      ]
    },
    {
      "compagny": "CHUV, Lausanne university hospital, Switzerland",
      "position": "Post Doctoral Researcher",
      "advisors": "Dr. Aurélie Edwards and Pr. Olivier Bonny",
      "url": "",
      "startDate": "2017-01",
      "endDate": "2017-03",
      "summary": "",
      "highlights": [
        "Improvements to the model developed during my doctoral thesis.", 
        "Publication of a second article"
      ]
    },
    //{
    //  "compagny": "Centre for Applied Mathematics in Bioscience and Medicine (CAMBAM), Mc Gill University, Montreal, Canada",
    //  "position": "Internship in a Team of Theoretical Physiology",
    //  "advisors": "Dr. Moisés Santillan, Pr. Michael Mackey",
    //  "url": "",
    //  "startDate": "2013-07",
    //  "endDate": "2013-08",
    //  "summary": "Improvements to the model developed during the previous internship.",
    //  "highlights": []
    //},
    //{
    //  "compagny": "Institut National de Recherche en Informatique et Automatique (INRIA), Team Dracula, Lyon",
    //  "position": "Internship in a Laboratory of Applied Mathematics",
    //  "advisors": "Dr. Laurent Pujo-menjouet (UCBL), Pr. Michael Mackey (Mc Gill, Canada)",
    //  "url": "",
    //  "startDate": "2013-01",
    //  "endDate": "2013-07",
    //  "summary": "Multiscale modeling of Zebrafish Somitogenesis. Development of a model accounting for the intra-cellular oscillator in each cell during somitogenesis.",
    //  "highlights": []
    //},
    //{
    //  "compagny": "Institut National de Recherche en Informatique et Automatique (INRIA), Team Dracula, Lyon",
    //  "position": "Internship in a Laboratory of Applied Mathematics",
    //  "advisors": "Dr. Laurent Pujo-menjouet (UCBL)",
    //  "url": "",
    //  "startDate": "2012-03",
    //  "endDate": "2012-07",
    //  "summary": "Mathematical modeling of somitogenesis, reaction- diffusion systems. Analysis of two mathematical models: cell-cycle and clock/wavefront models.",
    //  "highlights": []
    //},
    //{
    //  "compagny": "Laboratoire de Biométrie et Biologie Evolutive (LBBE), Team Modélisation et Ecotoxycologie Prédictive (MEPS), Lyon.",
    //  "position": "Internship in a Laboratory of Theoretical Ecology",
    //  "advisors": "Pr. Sandrine Charles (UCBL), Pr. Marie Laure Delignette Muller (Ecole Nationale Vétérinaire de Lyon)",
    //  "url": "",
    //  "startDate": "2011-06",
    //  "endDate": "2011-08",
    //  "summary": "Ecotoxicology of Daphnia Magna. Study of the impact of pollution on the growth of Daphnia Magna through mathematical models",
    //  "highlights": []
    //}
  ],
  "education": [
    {
      "institution": "Université Pierre et Marie Curie, Paris, Université de Lausanne, Switzerland",
      "memoryTitle": "Modeling of Calcium Homeostasis in the Rat and its Perturbations",
      "description": "Building of a mathematical model describing calcium homeostasis, including its analysis and simulation of pathologies",
      "advisors": "Dr. Aurélie Edwards and Pr. Olivier Bonny",
      "url": "",
      "area": "Applied Mathematics",
      "studyType": "PhD in Life Sciences",
      "startDate": "2013",
      "endDate": "2016"
    },
    {
      "institution": "Université Claude Bernard (UCBL), Lyon",
      "memoryTitle": "",
      "description": "",
      "advisors": "",
      "url": "",
      "area": "Mathematics, Biology, Programming",
      "studyType": "Master's Degree in Ecosiences, MIV",
      "startDate": "2011",
      "endDate": "2013"
    },
    {
      "institution": "Université Claude Bernard (UCBL), Lyon",
      "memoryTitle": "",
      "description": "",
      "advisors": "",
      "url": "",
      "area": "Mathematics, Biology, Programming",
      "studyType": " Licence (3 year degree)",
      "startDate": "2010",
      "endDate": "2011"
    },
    {
      "institution": "Lycée Claude Fauriel, Saint Etienne",
      "memoryTitle": "",
      "description": "",
      "advisors": "",
      "url": "",
      "area": "Mathematics, Physics, Biology, Geology",
      "studyType": " Preparatory School for Engineers",
      "startDate": "2008",
      "endDate": "2010"
    }
  ],
  "talks": [
    {
      "event": "Posit Conf 2023",
      "title": "Workshop: Web Design for Shiny Devs",
      "date": "2023-03-16",
      "links": [
        "https://webdesign4shiny.rinterface.com/",
        "https://github.com/posit-conf-2023/shiny-r-ui",
        "https://github.com/posit-conf-2023/shiny-r-ui-exercises",
      ],
      "slides": "https://webdesign4shiny.rinterface.com/slides/0-welcome/welcome#/title-slide",
      "video": ""
    },
    {
      "event": "Shiny Conf 2023: Data Science Hangout",
      "title": "Production ready apps for clinical trials",
      "date": "2023-09-17",
      "links": [
        "https://posit.co/data-science-hangout/"
      ],
      "slides": "",
      "video": "https://www.youtube.com/embed/JwrEB9cqNqg"
    },
    {
      "event": "R in Pharma",
      "title": "Workshop: Introduction to {shinyValidator}.",
      "date": "2022-11-02",
      "links": [
        "https://github.com/Novartis/shinyValidator",
        "https://github.com/RinteRface/rinpharma2022",
        "https://github.com/RinteRface/rinpharma2022-code"
      ],
      "slides": "https://rinpharma2022.rinterface.com/",
      "video": "https://www.youtube.com/embed/STpBxos_IXY"
    },
    {
      "event": "Shiny Conf 2022 by Appsilon",
      "title": "Invited talk: {shinyValidator}, toward a new audit process for Shiny apps quality through CI/CD.",
      "date": "2022-04-29",
      "links": [
        "https://github.com/RinteRface/AppsilonConf2022"
      ],
      "slides": "https://appsilonconf2022.rinterface.com",
      "video": "https://www.youtube.com/embed/Bly51jHDV20"
    },
    {
      "event": "R in Pharma",
      "title": "Talk: Outstanding User Interfaces with Shiny.",
      "date": "2021-11-04",
      "links": [
        "https://github.com/RinteRface/rinpharma2021"
      ],
      "slides": "https://rinpharma2021-talk.rinterface.com",
      "video": "https://www.youtube.com/embed/9Qm_b-hGAac"
    },
    {
      "event": "R in Pharma",
      "title": "Workshop: Unleash Shiny 2021.",
      "date": "2021-10-10",
      "links": [
        "https://github.com/RinteRface/unleash-shiny-2021"
      ],
      "slides": "https://rinpharma2021.rinterface.com",
      "video": "https://www.youtube.com/embed/p6ilISM_70U"
    },
    {
      "event": "Beyond DataViz",
      "title": "How to Improve the UI/UX of Your Shiny Apps (Podcast).",
      "date": "2021-09-29",
      "links": [
        "https://www.crowdcast.io/e/shiny-apps-UX-UI-design?__s=81h3pqtq7v4b70zpyfa1"
      ],
      "slides": "",
      "video": ""
    },
    {
      "event": "Rencontres R 2021",
      "title": "Workshop: `{shinyMobile}` Hands-on.",
      "date": "2021-09-07",
      "links": [
        "https://github.com/RinteRface/rencontresR2021"
      ],
      "slides": "https://rencontresr2021.rinterface.com",
      "video": ""
    },
    {
      "event": "Shiny Developers Series 2021",
      "title": "Podcast interview: Outstanding User Interfaces with David Granjon.",
      "date": "2021-05",
      "links": [
        "https://shinydevseries.com/interview/ep020/"
      ],
      "slides": "",
      "video": "https://www.youtube.com/embed/mxvMaoXOm70"
    },
    {
      "event": "R in Pharma 2020",
      "title": "Workshop: Unleash Shiny.",
      "date": "2020-10-09",
      "links": [
        "https://github.com/RinteRface/Unleash-Shiny",
        "https://github.com/RinteRface/Unleash-Shiny-Exercise-1",
        "https://github.com/RinteRface/Unleash-Shiny-Exercise-2",
        "https://github.com/RinteRface/Unleash-Shiny-Exercise-3",
        "https://github.com/RinteRface/Unleash-Shiny-Exercise-Part-3"
      ],
      "slides": "https://rinpharma2020.rinterface.com",
      "video": ""
    },
    {
      "event": "eRum 2020",
      "title": "Workshop: Advanced User Interfaces for Shiny Developers.",
      "date": "2020-05",
      "links": [
        "https://github.com/Novartis/Advanced-User-Interfaces-for-Shiny-Developers",
        "https://github.com/DivadNojnarg/eRum2020",
        "https://github.com/DivadNojnarg/eRum2020-handson"
      ],
      "slides": "https://erum2020.rinterface.com",
      "video": ""
    },
    {
      "event": "satRdayNeuch 2020",
      "title": "Oral presentation: An introduction to shinyMobile.",
      "date": "2020-03-14",
      "links": [
        "https://github.com/DivadNojnarg/satRdayNeuch2020"
      ],
      "slides": "https://satrday2020.rinterface.com",
      "video": ""
    },
    {
      "event": "Zurich R User Group",
      "title": "Oral presentation: shinyMobile, Build Native Looking Shiny Apps.",
      "date": "2020-01-29",
      "links": [
        "https://github.com/DivadNojnarg/Zurich_R_Meetup_2020"
      ],
      "slides": "https://zurichrmeetup2020.rinterface.com",
      "video": ""
    },
    {
      "event": "Basel R User Group",
      "title": "Oral presentation: Development of a web application to represent models of calcium and phosphate homeostasis using R.",
      "date": "2019-12-05",
      "links": [
        "https://github.com/DivadNojnarg/BaselR2019"
      ],
      "slides": "https://baselrmeetup2019.rinterface.com",
      "video": ""
    },
    {
      "event": "Shiny Developers Series 2019",
      "title": "Podcast interview: Production-ready UIs for Shiny.",
      "date": "2019-08",
      "links": [
        "https://shinydevseries.com/interview/ep004/",
        "https://www.youtube.com/watch?v=vaK3sknxe4c&embeds_euri=https%3A%2F%2Fshinydevseries.com%2F&feature=emb_imp_woyt",
        "https://github.com/DivadNojnarg/shinyDevSeriesEp4"
      ],
      "slides": "",
      "video": "https://www.youtube.com/embed/0oi6tGzHUHM"
    },
    {
      "event": "useR 2019",
      "title": "Poster presentation: A Shiny Powered Virtual Patient.",
      "date": "2019-07-09/2019-07-12",
      "links": [
        "https://github.com/DivadNojnarg/userR2019"
      ],
      "slides": "",
      "video": ""
    },
    {
      "event": "Zurich R User Group",
      "title": "Oral presentation: shinyMobile, Build Native Looking Shiny Apps.",
      "date": "2019-05-27",
      "links": [
        "https://github.com/DivadNojnarg/Zurich_R_Meetup_2019"
      ],
      "slides": "https://zurichrmeetup2019.rinterface.com",
      "video": ""
    }
  ], 
  "awards": [
    {
      "title": "2020 RStudio Shiny Contest",
      "date": "2020",
      "url": "https://community.rstudio.com/t/deminr-a-minesweeper-for-r-2020-shiny-contest-submission/56356",
      "awarder": "Posit (formerly RStudio)",
      "summary": "Runner-Up price: `{deminR}` a minesweeper for R."
    },
    {
      "title": " 2019 RStudio Shiny Contest",
      "date": "2019",
      "url": "https://community.rstudio.com/t/shiny-contest-submission-a-virtual-lab-for-teaching-physiology/25348",
      "awarder": "Posit (formerly RStudio)",
      "summary": "Runner-Up price: A Virtual Lab for Teaching Physiology."
    }
  ],
  "books": [
    {
      "title": "Outstanding User Interfaces with Shiny",
      "authors": "David Granjon",
      "publisher": "CRC Press, R series",
      "startDate": "2018",
      "releaseDate": "2022",
      "image": "./book.jpg",
      "url": [
        "https://unleash-shiny.rinterface.com",
        "https://www.routledge.com/Outstanding-User-Interfaces-with-Shiny/Granjon/p/book/9780367643652",
        "https://github.com/DivadNojnarg/outstanding-shiny-ui"
      ],
      "description": "This book provides the necessary knowledge to extend Shiny's layout." 
    }
  ],
  "publications": [
    {
      "title": "Coupling between Phosphate and Calcium Homeostasis: A Mathematical Model.",
      "authors": "D. Granjon, O. Bonny, A. Edwards",
      "publisher": "American Journal of Physiology-Renal Physiology, 313(6): F1181-F1199",
      "releaseDate": "2017",
      "doi": "10.1152/ajprenal.00271.2017",
      "url": "",
      "abstract": "Description"
    },
    {
      "title": "A Model of Calcium Homeostasis in the Rat.",
      "authors": "D. Granjon, O. Bonny, A. Edwards",
      "publisher": "American Journal of Physiology-Renal Physiology, 311 (5): F1047-F1062",
      "releaseDate": "2016",
      "doi": "10.1152/ajprenal.00230.2016",
      "url": "",
      "abstract": "Description"
    }
  ],
  "skills": [
    {
      "name": "Shiny Dev",
      "level": "Expert",
      "keywords": [
        "golem",
        "shinytest2",
        "profVis",
        "shinyloadtest"
      ]
    },
    {
      "name": "Web Dev",
      "level": "Expert",
      "keywords": [
        "Shiny",
        "HTML",
        "CSS",
        "JavaScript",
        "React",
        "Framework7 (mobile)",
        "Bootstrap",
        "webpack",
        "esbuild"
      ]
    },
    {
      "name": "Data",
      "level": "Expert",
      "keywords": [
        "R",
        "tidyverse",
        "echarts4R/echarts.js",
        "visNetwork/vis.js",
        "RPostgres"
      ]
    },
    {
      "name": "Reporting",
      "level": "Expert",
      "keywords": [
        "rmarkdown",
        "quarto",
        "Latex",
        "bookdown"
      ]
    },
    {
      "name": "DevOps",
      "level": "Advanced",
      "keywords": [
        "Git",
        "GitHub Actions",
        "GitLab CI",
        "GitLab runners",
        "Docker",
        "OpenShift"
      ]
    }
  ],
  "languages": [
    {
      "language": "French",
      "fluency": "Native"
    },
    {
      "language": "English",
      "fluency": "C1"
    }
  ],
  "interests": [
    {
      "name": "Sport",
      "keywords": [
        "Cycling",
        "Hicking",
        "Skying"
      ]
    }
  ],
  "references": [
    {
      "name": "Dr. Douglas Robinson",
      "reference": "robinson_dm@hotmail.com"
    },
    {
      "name": "Dr. Aurélie Edwards",
      "reference": "aued@bu.edu"
    },
    {
      "name": "Pr. Olivier Bonny",
      "reference": "olivier.bonny@unil.ch"
    },
    {
      "name": "Dr. Laurent Pujo-Menjouet",
      "reference": "pujo@math.univ-lyon1.fr"
    },
    {
      "name": "Dr. Diane de Zélicourt",
      "reference": "diane.dezelicourt@physiol.uzh.ch"
    },
    {
      "name": "Pr. Vartan Kurtcuoglu",
      "reference": "vartan.kurtcuoglu@uzh.ch"
    }
  ],
  "projects": [
    {
      "name": "shinyValidator",
      "image": "",
      "description": "Audit Shiny apps quality and performance in few steps.",
      "highlights": [
        "Multiple levels of testings are offered: startup and crash tests, performance tests (load test and global code profiling), reactivity audit as well as output tests",
        "All results are gathered in an HTML report uploaded and available to everyone on any CI/CD plaform or RStudio Connect"
      ],
      "keywords": [
        "Shiny", "Crash test", "profiling", "load test"
      ],
      "startDate": "2022-04",
      "endDate": "Present",
      "url": "http://opensource.nibr.com/shinyValidator",
      "roles": [
        "Lead developer and maintainer"
      ],
      "type": "R package"
    },
    {
      "name": "shinyHeatmap",
      "image": "",
      "description": "Seamlessly track Shiny apps usage without exposing any sensitive user data.",
      "highlights": [],
      "keywords": [
        "Shiny", "heatmap.js", "Tracking"
      ],
      "startDate": "2022-06",
      "endDate": "Present",
      "url": "https://rinterface.github.io/shinyHeatmap",
      "roles": [
        "Lead developer and maintainer"
      ],
      "type": "R package"
    },
    {
      "name": "charpente",
      "image": "https://camo.githubusercontent.com/27e22ee18a88292d36fb68d84e09e535b135c50b237b908a01c5ce00dfabdc5e/68747470733a2f2f72696e746572666163652e636f6d2f696e73742f696d616765732f6368617270656e74652e706e67",
      "description": "Seamlessly create new HTML template for Shiny.",
      "highlights": [],
      "keywords": [
        "Shiny", "Template", "UI", "esbuild"
      ],
      "startDate": "2020-09",
      "endDate": "Present",
      "url": "https://rinterface.github.io/shinyHeatmap",
      "roles": [
        "Lead developer and maintainer"
      ],
      "type": "R package"
    },
    {
      "name": "shinyMobile",
      "image": "https://github.com/RinteRface/shinyMobile/raw/master/man/figures/logo.png",
      "description": "Develop outstanding {shiny} apps for iOS, Android, desktop as well as beautiful {shiny} gadgets. {shinyMobile} is built on top of the latest Framework7 template.",
      "highlights": [],
      "keywords": [
        "Shiny", "Mobile", "JavaScript"
      ],
      "startDate": "2018-06",
      "endDate": "Present",
      "url": "https://shinymobile.rinterface.com",
      "roles": [
        "Lead developer and maintainer"
      ],
      "type": "R package"
    },
    {
      "name": "bs4Dash",
      "image": "https://camo.githubusercontent.com/8b549d9305720d9c38118ad2f37fc218c13ad4de15384fe196d9f64befa5e25b/68747470733a2f2f72696e746572666163652e636f6d2f696e73742f696d616765732f627334446173682e737667",
      "description": "Develop outstanding Shiny dashboard powered by Bootstrap 4.",
      "highlights": [],
      "keywords": [
        "Shiny", "Dashboard", "Bootstrap 4"
      ],
      "startDate": "2018-01",
      "endDate": "Present",
      "url": "https://bs4dash.rinterface.com",
      "roles": [
        "Lead developer and maintainer"
      ],
      "type": "R package"
    },
    {
      "name": "shinydashboard+",
      "image": "https://camo.githubusercontent.com/25bb653d828cc411aa1eabc6e4a097977fc6cae173c89c9056d77937f0588790/68747470733a2f2f72696e746572666163652e636f6d2f696e73742f696d616765732f7368696e7964617368626f617264506c75732e737667",
      "description": "shinydashboard extensions.",
      "highlights": [],
      "keywords": [
        "Shiny", "Dashboard", "shinydashboard", "Bootstrap 3"
      ],
      "startDate": "2017-01",
      "endDate": "Present",
      "url": "https://shinydashboardplus.rinterface.com",
      "roles": [
        "Lead developer and maintainer"
      ],
      "type": "R package"
    }
  ]
}
export default cv;